<template>
  <inventoryProductsCategoriesList/>
</template>
<script>
import inventoryProductsCategoriesList from '@/components/modules/papeleria/products/categories/list'
export default {
  name: 'inventoryCategories',
  components: {
    inventoryProductsCategoriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/products/categories/list.vue